import { createApi } from "@reduxjs/toolkit/query/react";
import { Tag, TagCategory } from "../../models/tag";
import { axiosBaseQuery, QueryArg } from "../axiosConfig";
import { RequestMethod } from "../enum";
import { sortTags } from "./helpers";
import { GetTagsArgs } from "./types";

const getTags = (args: GetTagsArgs): QueryArg => ({
  url: "/search",
  method: RequestMethod.POST,
  data: args,
});

const getTagCategories = (): QueryArg => ({
  url: "/categories",
  method: RequestMethod.GET,
});

export const tagsApi = createApi({
  reducerPath: "tagsApi",
  baseQuery: axiosBaseQuery({
    baseUrl: "/tags",
  }),
  tagTypes: ["Tags"],
  endpoints: (build) => ({
    getTags: build.query<Tag[], GetTagsArgs>({
      query: getTags,
      transformResponse: ({ tags }: { tags: Tag[] }) => sortTags(tags),
      providesTags: ["Tags"],
    }),
    getTagCategories: build.query<TagCategory[], void>({
      query: getTagCategories,
      transformResponse: ({ categories }: { categories: TagCategory[] }) =>
        categories.sort((a, b) => a.name.localeCompare(b.name)),
    }),
  }),
});
